import { ActiveGameStore as BaseStore } from '@bn-games/history-core';
import type { ActiveSession } from './types.js';
import { HISTORY_SCHEMA_VERSION } from './types.js';
import { normalizeSessionVariant } from './legacyVariant.js';

class DominoActiveGameStore extends BaseStore<ActiveSession> {
  override peek(): ActiveSession | null {
    const session = super.peek();
    return session === null ? null : normalizeSessionVariant(session);
  }
}

// Per-app singleton wrapping @bn-games/history-core's generic store with
// domino's storage key + schema version + shape predicate. Both the recorder
// and main.ts read/write via this instance.
export const ActiveGameStore = new DominoActiveGameStore({
  storageKey: 'domino-active-game',
  schemaVersion: HISTORY_SCHEMA_VERSION,
  isValid: (parsed) => parsed.seed !== undefined && Array.isArray(parsed.moves),
});
